import { useEffect, useState } from 'react';
import { loadUploadChecks, uploadIdentity, type UploadCheck } from '../../studio/engine-kit/upload-checks';

/* Ядро проверок (разбор ответа, подписи, «подходит ли снимок») — engine-kit/upload-checks.ts: его же читают движки экранов */
export { checkItem, checkLabel, checkOk, type CheckItem, type UploadCheck } from '../../studio/engine-kit/upload-checks';

/** Проверки загрузки сервера (лицо, резкость, повторы, размер — GET /app/uploads/{id}): ничего не выдумываем на клиенте. */
export function useUploadChecks(ids: Record<string, string>) {
  const identity = uploadIdentity(ids);
  const [state, setState] = useState<{ identity: string; checks: Record<string, UploadCheck> }>({ identity: '', checks: {} });
  useEffect(() => {
    const entries = JSON.parse(identity) as Array<[string, string]>;
    if (!entries.length) return;
    const request = new AbortController();
    void loadUploadChecks(Object.fromEntries(entries), request.signal).then(checks => {
      if (request.signal.aborted) return;
      setState({ identity, checks });
    });
    return () => request.abort();
  }, [identity]);
  return state.identity === identity ? state.checks : {};
}
